var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Wrapper',[_c('Topbar',{attrs:{"button":"goToPanel","logo":"tipbox","step":"3/3"}}),_c('h2',{staticClass:"text-center mb-3"},[_vm._v(_vm._s(_vm.$t('header')))]),_c('p',{staticClass:"text-center pre-line mb-4"},[_vm._v(_vm._s(_vm.$t('description')))]),_c('FeatureColumns',{attrs:{"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }